'use client';

import {
  TheHeader as BaseTheHeader,
  TheHeaderProps,
} from '@hyphengroup/cms-components';
import { usePathname } from 'next/navigation';
import { getOtherLocale, LocaleConfig } from '$/(cms)/_modules/otherLocale';
import { pushDataLayer } from '$/components/cms/pushDataLayer';
import { useClientContext } from '$/modules/context/client';

export function TheHeader({
  localeConfig,
  ...props
}: Omit<TheHeaderProps, 'pushDataLayer' | 'languageToggle'> & {
  /**
   * The brand's locales, for the language toggle that links the same page in the other one
   * (CMS-2008). `null` where the header must not link it: the 404 page, which CloudFront serves
   * under the URL the visitor asked for rather than its own.
   */
  localeConfig: LocaleConfig | null;
}) {
  // A single-locale brand has no prefix: the server context's rule, not a second one here.
  const { langPrefix } = useClientContext();
  // The path the visitor has, on the server as well (Next renders with the URL before the proxy's
  // rewrite), and it follows client navigations under a layout that is not rendered again.
  const path = usePathname() ?? '';
  const otherLocale =
    langPrefix && localeConfig ? getOtherLocale(path, localeConfig) : null;

  return (
    <BaseTheHeader
      {...props}
      pushDataLayer={pushDataLayer}
      languageToggle={
        otherLocale
          ? { href: otherLocale.path, hrefLang: otherLocale.lang }
          : undefined
      }
    />
  );
}
